import $http from '../connectionProxy'

export const get = (studentId) => {
  return $http.get(`/responsibles_area/students/${studentId}/show_school_routine`)
}
